import React from 'react';
import { initialKhachHangValues, KhachHangFormValues, khachHangSchema } from '../schemas';
import { AritoFormV2, DialogV2, AritoIcon } from '@/components/custom/erp';
import { HeaderTab, GeneralInfoTab, HddtTab, OtherTab } from './tabs';
import type { KhachHang } from '@/types/schemas';
import { useGeneralInfoState } from '../hooks';
import type { FormMode } from '@/types/form';

export interface FormDialogProps {
  open: boolean;
  mode: FormMode;
  formMode?: FormMode;
  initialData?: KhachHang;
  onClose: () => void;
  onSubmit?: (data: any) => void;
  zIndex?: number;
}

export default function FormDialog({ open, mode, formMode, initialData, onClose, onSubmit, zIndex }: FormDialogProps) {
  const resolvedMode = mode || formMode || 'add';
  const generalInfoState = useGeneralInfoState(resolvedMode, initialData);

  const handleFormSubmit = async (data: KhachHangFormValues) => {
    const updatedData = {
      ...data,
      is_customer: true,
      is_vendor: false,
      customer_group1: generalInfoState.nhomKH1?.uuid || null,
      customer_group2: generalInfoState.nhomKH2?.uuid || null,
      customer_group3: generalInfoState.nhomKH3?.uuid || null,
      region: generalInfoState.khuVuc?.uuid || null,
      account: generalInfoState.taiKhoan?.uuid || null,
      payment_term: generalInfoState.hanThanhToan?.uuid || null,
      payment_method: generalInfoState.phuongThucThanhToan?.uuid || null,
      ma_nvbh: generalInfoState.nhanVien?.uuid || null,
      sales_rep: generalInfoState.nhanVien?.uuid || null,
      credit_limit: data.credit_limit || 0
    };

    onSubmit?.(updatedData);
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={
        resolvedMode === 'add'
          ? 'Thêm mới khách hàng'
          : resolvedMode === 'edit'
            ? 'Sửa khách hàng'
            : 'Xem chi tiết khách hàng'
      }
      maxWidth='lg'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
      paperClassName='w-[min(980px,calc(100vw-16px))]'
      zIndex={zIndex}
    >
      <AritoFormV2
        mode={resolvedMode}
        initialData={initialData as any}
        onSubmit={handleFormSubmit}
        onClose={onClose}
        schema={khachHangSchema}
        className='w-full min-w-0 max-w-full'
        headerFields={<HeaderTab mode={resolvedMode} />}
        tabs={[
          { id: 'basic_info', label: 'Thông tin chung', component: <GeneralInfoTab {...generalInfoState} /> },
          { id: 'other', label: 'Khác', component: <OtherTab /> },
          { id: 'hddt', label: 'HDDT', component: <HddtTab mode={resolvedMode} /> }
        ]}
      />
    </DialogV2>
  );
}
